/* [#34] Second picture on product cards (snippets/luxe-collection-card.liquid).
   Loaded from layout/theme.liquid only while Theme settings > LUXE product cards >
   "Second picture on cards" is on. Without this script (or with the setting off) a
   card is exactly what it was before: one picture, no dots.

   What it does:
   - Marks each two-picture card "is-ready", which lets the CSS show the second
     slide (desktop: a crossfade on hover; phone: a two-slide swipe with dots).
   - Fetches the second picture only when it is about to be needed: on desktop at
     the first pointer-enter or keyboard focus, on phones when the card comes
     within 300px of the screen. Until then the <img> has no src, so a grid of
     twenty cards costs nothing extra.
   - On phones, keeps the dots in step with the slide that is in view.
   - Watches for cards added later (the gift finder, section re-renders). */
(function () {
  'use strict';
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var io = null;

  function load(media) {
    var img = media.querySelector('.luxe-cc__slide--2 img[data-src]');
    if (!img) return;
    if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function dots(media) {
    var track = media.querySelector('.luxe-cc__track');
    var list = media.querySelectorAll('.luxe-cc__dots i');
    if (!track || !list.length) return;
    var w = track.clientWidth || 1;
    var i = Math.min(list.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
    for (var k = 0; k < list.length; k++) list[k].classList.toggle('is-on', k === i);
  }

  function arm(media) {
    if (media.hasAttribute('data-luxe-cc-armed')) return;
    media.setAttribute('data-luxe-cc-armed', '');
    media.classList.add('is-ready');
    var card = media.closest('.luxe-cc') || media;
    if (FINE) {
      var once = function () { load(media); card.removeEventListener('pointerenter', once); card.removeEventListener('focusin', once); };
      card.addEventListener('pointerenter', once);
      card.addEventListener('focusin', once);
    } else {
      if (!io && 'IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { load(e.target); io.unobserve(e.target); } });
        }, { rootMargin: '300px 0px' });
      }
      if (io) io.observe(media); else load(media);
      var track = media.querySelector('.luxe-cc__track');
      if (track) {
        var t = null;
        track.addEventListener('scroll', function () {
          if (t) cancelAnimationFrame(t);
          t = requestAnimationFrame(function () { dots(media); });
        }, { passive: true });
      }
    }
  }

  function init(root) {
    var list = (root || document).querySelectorAll('[data-luxe-cc-swipe]');
    for (var i = 0; i < list.length; i++) arm(list[i]);
  }

  init();
  /* cards that arrive later: the gift finder's picks, section re-renders, quick view */
  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; init(); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
